import BaseApi from './baseApi';
import IWarehouse from '../models/IWarehouse';
import IAuthentication from '../models/IAuthentication';
export default class WarehouseApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Warehouses");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetWarehouses() : Promise<IWarehouse[]> {
        let json : string = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var company: IWarehouse[] = [];
            company = response.data as IWarehouse[];
            return company;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetWarehousesShared(idCompany: string) : Promise<IWarehouse[]> {
        let json : string = this.getJsonReadShared(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var company: IWarehouse[] = [];
            company = response.data as IWarehouse[];
            return company;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetWarehousesByCompanyId(companyId: string) : Promise<IWarehouse[]> {
        let json : string = this.getJsonReadWithIdCompany(companyId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var company: IWarehouse[] = [];
            company = response.data as IWarehouse[];
            return company;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async IsWarehouseShared(companyId: string, idWarehouse: string) {
        let json : string = this.getJsonReadIsWarehouseShared(companyId, idWarehouse);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var company: IWarehouse[] = [];
            company = response.data as IWarehouse[];
            return company;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveWarehouse(warehouse: IWarehouse) : Promise<string> {
        const json = this.getJsonSave(warehouse);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateWarehouse(warehouse: IWarehouse) : Promise<boolean> {
        const json = this.getJsonUpdate(warehouse);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteWarehouse(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "Warehouses",
            "conditions": [{
                "Item1": "Warehouses",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(warehouse: IWarehouse) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": warehouse.name
            }, {
                "Item1": "street",
                "Item2": warehouse.street
            }, {
                "Item1": "number",
                "Item2": warehouse.number
            }, {
                "Item1": "city",
                "Item2": warehouse.city
            }, {
                "Item1": "zipCode",
                "Item2": warehouse.zipCode
            }, {
                "Item1": "idListCountry",
                "Item2": warehouse.idListCountry
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": warehouse.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": warehouse.phoneNumber
            }, {
                "Item1": "idCompany",
                "Item2": warehouse.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "Warehouses"
        };
        return json;
    }

    private getJsonUpdate(warehouse: IWarehouse) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": warehouse.name
            }, {
                "Item1": "street",
                "Item2": warehouse.street
            }, {
                "Item1": "number",
                "Item2": warehouse.number
            }, {
                "Item1": "city",
                "Item2": warehouse.city
            }, {
                "Item1": "zipCode",
                "Item2": warehouse.zipCode
            }, {
                "Item1": "idListCountry",
                "Item2": warehouse.idListCountry
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": warehouse.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": warehouse.phoneNumber
            }, {
                "Item1": "idCompany",
                "Item2": warehouse.idCompany
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "Warehouses",
            "keyvalue": warehouse.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "id"
            }, {
                "Item1": "Warehouses",
                "Item2": "name"
            }, {
                "Item1": "Warehouses",
                "Item2": "street"
            }, {
                "Item1": "Warehouses",
                "Item2": "number"
            }, {
                "Item1": "Warehouses",
                "Item2": "city"
            }, {
                "Item1": "Warehouses",
                "Item2": "zipCode"
            }, {
                "Item1": "Warehouses",
                "Item2": "idListCountry"
            }, {
                "Item1": "ListCountries",
                "Item2": "countryName"
            }, {
                "Item1": "ListCountries",
                "Item2": "code"
            }, {
                "Item1": "Warehouses",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "Warehouses",
                "Item2": "phoneNumber"
            }, {
                "Item1": "Warehouses",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "Warehouses"
            }, {
                "Item1": "ListPhonePrefixes"
            }, {
                "Item1": "ListCountries"
            }],
            "joins": [{
                "Item1": "Warehouses",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }, {
                "Item1": "Warehouses",
                "Item2": "IdListCountry",
                "Item3": "ListCountries",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Warehouses",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }],
            "orderBy": [{
                "Item1": "Warehouses.name"
            }]
        };
        return json;
    }

    private getJsonReadIsWarehouseShared(idCompany: string, idWarehouse: string) : any {
        const json = {
            "fields": [{
                "Item1": "WarehousesShared",
                "Item2": "idWarehouse"
            }, {
                "Item1": "WarehousesShared",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "WarehousesShared"
            }],
            "conditions": [{
                "Item1": "WarehousesShared",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "AND"
            }, {
                "Item1": "WarehousesShared",
                "Item2": "idWarehouse",
                "Item3": "=",
                "Item4": idWarehouse
            }]
        };
        return json;
    }

    private getJsonReadShared(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "",
                "Item2": "*"
            }],
            "tables": [{
                "Item1": "GetWarehouses('" + idCompany + "')"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "id"
            }, {
                "Item1": "Warehouses",
                "Item2": "name"
            }, {
                "Item1": "Warehouses",
                "Item2": "street"
            }, {
                "Item1": "Warehouses",
                "Item2": "number"
            }, {
                "Item1": "Warehouses",
                "Item2": "city"
            }, {
                "Item1": "Warehouses",
                "Item2": "zipCode"
            }, {
                "Item1": "Warehouses",
                "Item2": "idListCountry"
            }, {
                "Item1": "ListCountries",
                "Item2": "countryName"
            }, {
                "Item1": "ListCountries",
                "Item2": "code"
            }, {
                "Item1": "Warehouses",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "Warehouses",
                "Item2": "phoneNumber"
            }, {
                "Item1": "Warehouses",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "Warehouses"
            }, {
                "Item1": "ListPhonePrefixes"
            }, {
                "Item1": "ListCountries"
            }],
            "joins": [{
                "Item1": "Warehouses",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }, {
                "Item1": "Warehouses",
                "Item2": "IdListCountry",
                "Item3": "ListCountries",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Warehouses",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Warehouses",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": idCompany
            }],
            "orderby": [{
                "Item1": "Warehouses.name"
            }]
        };
        return json;
    }
}
